import Box from "@mui/material/Box";

export default function FooterInfo() {
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      <a href="https://www.linkedin.com/company/glimpseit/"><img src="/images/linkedin.png" alt="linkedin" /></a>
    </Box>
  );
}
